<template>
  <form
    id="forgot-password-form"
    @submit.prevent="onFormSubmit"
  >
    <template v-if="resetSucceeded !== true">
      <tg-form-input-text
        v-model="username"
        type="email"
        name="username"
        :label="$t('general.email')|capitalize"
        :required="true"
        :validation="$v.username"
      />
      <p
        v-if="errorMessage"
        class="text-body-2 text--error"
        v-text="errorMessage"
      />
      <p
        v-else
        class="text-body-2"
        v-text="$t('text.account.forgot_password_description')"
      />
      <tg-button-group>
        <tg-button
          v-if="isValid && !resetRequested"
          :loading="isLoading"
          @click="onFormSubmit; clear"
        >
          {{ $t('general.send') | capitalize }}
        </tg-button>
        <tg-button
          v-else
          @click.prevent="$emit('go-to-login')"
        >
          {{ $t('customer.login.decline') | capitalize }}
        </tg-button>
        <tg-button
          variant="text"
          @click.prevent="$emit('go-to-login')"
        >
          {{ $t('general.login') | capitalize }}
        </tg-button>
      </tg-button-group>
    </template>
    <template v-else>
      <p
        class="text-body-2"
        v-text="$t('customer.resetting.request.check_email')"
      />
      <tg-button-group>
        <tg-button
          @click.prevent="$emit('go-to-login')"
        >
          {{ $t('general.login') | capitalize }}
        </tg-button>
        <tg-button
          variant="text"
          @click.prevent="$emit('go-to-login')"
        >
          {{ $t('customer.login.decline') | capitalize }}
        </tg-button>
      </tg-button-group>
    </template>
  </form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';

import TgButton from '../buttons/TgButton';
import TgButtonGroup from '../buttons/TgButtonGroup';
import TgFormInputText from './fields/TgFormInputText';
import { SET_USERNAME } from '~/store/account/credentials';

export default {
  name: 'TgForgotPasswordForm',

  components: {
    TgButtonGroup,
    TgButton,
    TgFormInputText,
  },

  props: {
    url: {
      type: String,
      required: false,
      default: null,
    },
  },

  data () {
    return {
      isLoading: false,
      isValid: true,
      errorMessage: null,
      resetSucceeded: false,
      resetRequested: false,
    };
  },

  computed: {
    username: {
      set (username) {
        this.$store.commit(
          `account/credentials/${SET_USERNAME}`,
          username.toLowerCase(),
        );
      },
      get () {
        return this.$store.state.account.credentials.username;
      },
    },
  },

  validations: {
    username: {
      required,
      email,
    },
  },

  methods: {
    processResponse (response) {
      console.log(response.status);
      switch (response.status) {
        case 200:
        case 204:
          this.resetSucceeded = true;
          this.resetRequested = true;
          break;
        case 404:
          this.resetRequested = true;
          this.errorMessage = this.$t('customer.resetting.request.non_existing');
          break;
        case 422:
        default:
          this.errorMessage = this.$t('customer.resetting.request.failed');
          break;
      }
    },
    onFormSubmit () {
      this.$v.$touch();
      this.errorMessage = null;

      if (!this.$v.$invalid) {
        this.isLoading = true;
        this.$store.dispatch('customers/resetPassword', {
          email: this.username,
        })
          .then((response) => {
            this.processResponse(response);
          })
          .catch((error) => {
            this.processResponse(error.response);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    clear () {
      this.resetSucceeded = false;
      this.resetRequested = false;
    },
  },
};
</script>
